import { Flex, Spin } from 'antd';
import { useContext, useEffect } from 'react';
import AppContext from '../../contexts/data/AppContext';

export const MOBILE_REDIRECT_PAGE_PATH = '/mobile-redirect';

interface NavigatorWithUAData extends Navigator {
  userAgentData?: {
    platform?: string;
  };
};

const MobileRedirectPage: React.FC = () => {
  const { item, fetch } = useContext(AppContext);

  useEffect(() => {
    fetch();
  }, [fetch]);

  useEffect(() => {
    if (!item?.stores?.ios?.url || !item?.stores?.android?.url) return;

    const ua = window.navigator.userAgent ?? '';
    const uaPlatform = (window.navigator as NavigatorWithUAData).userAgentData?.platform ?? '';

    const isIOSFromUA = /iPhone|iPad|iPod/i.test(ua) || /iPhone|iPad|iPod/i.test(uaPlatform);
    const isIpadOrMac = (uaPlatform === 'MacIntel' || uaPlatform === 'macOS');
    const shouldAppStoreRedirect = isIOSFromUA || isIpadOrMac;

    if (shouldAppStoreRedirect) {
      window.location.href = item?.stores?.ios?.url;
    } else {
      window.location.href = item?.stores?.android?.url;
    }
  }, [item]);

  return <Flex justify="center" align="center" style={{ height: '100vh' }}>
    <Spin spinning />
  </Flex>;
};

export default MobileRedirectPage;
